import { UUID } from 'crypto';

export interface IFeedbackService {
  submitFeedback(args: {
    feedbackType: 'positive' | 'negative';
    sessionId: UUID;
    queryText: string;
    accessToken: string;
    feedbackEntryUUID?: UUID;
    userFeedbackText?: string;
  }): Promise<UUID>;
}

export class FeedbackService implements IFeedbackService {
  async submitFeedback(args: {
    feedbackType: 'positive' | 'negative';
    sessionId: UUID;
    queryText: string;
    accessToken: string;
    feedbackEntryUUID?: UUID;
    userFeedbackText?: string;
  }): Promise<UUID> {
    const response = await fetch('/api/chatbot/createChatbotFeedback', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        feedbackType: args.feedbackType,
        sessionId: args.sessionId,
        queryText: args.queryText,
        accessToken: args.accessToken,
        feedbackEntryUUID: args.feedbackEntryUUID,
        userFeedbackText: args.userFeedbackText,
      }),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ message: 'Unknown error during feedback submission' }));
      console.error('Feedback submission failed:', errorData);
      throw new Error(errorData.message);
    }
    const responseData = await response.json();
    return responseData.feedbackEntryUUID;
  }
}
